import { css } from '@emotion/react'
import { typographyClasses } from '@mui/material'

export const radioGroup = css`
  gap: 8px;
`

export const radio = css`
  margin-left: 0;
  margin-right: 0;
  gap: 8px;

  .${typographyClasses.root} {
    font-size: 16px;
  }
`
